import { pricingPlans } from '../../../mocks/home';
import { WHATSAPP_CTA_URL } from '../../../data/whatsapp';
import { openTrackedWhatsAppUrl } from '../../../lib/tracking/whatsapp';

export default function Pricing() {
  const goToWhatsApp = () => {
    void openTrackedWhatsAppUrl(WHATSAPP_CTA_URL, { newTab: false });
  };

  return (
    <section id="preco" className="py-28" style={{ background: 'transparent' }}>
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <span
            className="inline-block px-4 py-1.5 rounded-full text-xs font-semibold mb-4"
            style={{ background: 'var(--badge-bg)', color: 'var(--gold-hover)', fontFamily: "'DM Sans', sans-serif", border: '1px solid rgba(200,131,42,0.15)' }}
          >
            Dois jeitos de emocionar
          </span>
          <h2
            className="text-3xl md:text-4xl font-bold mb-4"
            style={{ color: 'var(--heading-ink)', fontFamily: "'DM Sans', sans-serif", fontWeight: 800, letterSpacing: '-0.03em' }}
          >
            Escolha como quer emocionar
          </h2>
          <p
            className="text-base max-w-xl mx-auto"
            style={{ color: 'var(--text-strong)', fontFamily: "'DM Sans', sans-serif", fontWeight: 300 }}
          >
            Escolha a música por <strong style={{ fontWeight: 600, color: 'var(--heading-ink)' }}>R$ 34,90</strong>
            ou transforme o presente em um vídeo profissional com todas as suas fotos.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-7 items-stretch max-w-4xl mx-auto">
          {pricingPlans.map((plan) => {
            const [intPart, decPart] = plan.price.split(',');
            const isHi = plan.highlight;
            return (
              <div
                key={plan.id}
                className={`glass home-card rounded-3xl p-6 lg:p-7 relative flex flex-col h-full ${isHi ? 'md:-translate-y-3 z-10' : ''}`}
                style={{
                  backdropFilter: 'blur(18px)',
                  WebkitBackdropFilter: 'blur(18px)',
                  border: isHi ? '1.5px solid var(--gold)' : '1.5px solid var(--border-soft)',
                  boxShadow: isHi
                    ? '0 16px 50px rgba(255,145,77,0.22), 0 4px 14px rgba(0,0,0,0.10)'
                    : '0 8px 32px rgba(0,0,0,0.06)',
                }}
              >
                {/* "Mais escolhido" ribbon */}
                {plan.badge && (
                  <span
                    className="absolute left-1/2 -translate-x-1/2 -top-3.5 px-4 py-1 rounded-full text-[11px] font-bold uppercase tracking-widest whitespace-nowrap"
                    style={{ background: 'var(--gold)', color: '#fff', fontFamily: "'DM Sans', sans-serif", boxShadow: '0 4px 16px rgba(255,145,77,0.40)' }}
                  >
                    {plan.badge}
                  </span>
                )}

                {/* Tier name */}
                <h3
                  className="text-lg font-bold mb-1"
                  style={{ color: 'var(--heading-ink)', fontFamily: "'DM Sans', sans-serif", fontWeight: 800, letterSpacing: '-0.02em' }}
                >
                  {plan.name}
                </h3>
                <p
                  className="text-xs mb-5"
                  style={{ color: 'var(--text-soft)', fontFamily: "'DM Sans', sans-serif" }}
                >
                  {plan.tagline}
                </p>

                {/* Price */}
                <div className="flex items-start gap-1 mb-6">
                  <span className="text-base font-medium mt-2" style={{ color: 'var(--text-soft)', fontFamily: "'DM Sans', sans-serif" }}>
                    R$
                  </span>
                  <span className="text-5xl font-bold leading-none" style={{ color: 'var(--heading-ink)', fontFamily: "'DM Sans', sans-serif", fontWeight: 800 }}>
                    {intPart}
                  </span>
                  <span className="text-2xl font-semibold mt-1" style={{ color: 'var(--heading-ink)', fontFamily: "'DM Sans', sans-serif", fontWeight: 700 }}>
                    ,{decPart}
                  </span>
                </div>

                {/* Benefits */}
                <ul className="flex flex-col gap-3 mb-8">
                  {plan.benefits.map((benefit, i) => (
                    <li key={i} className="flex items-start gap-3">
                      <div
                        className="w-5 h-5 flex items-center justify-center rounded-full flex-shrink-0 mt-0.5"
                        style={{ background: isHi ? 'var(--gold)' : 'var(--badge-bg)' }}
                      >
                        <i className="ri-check-line text-xs" style={{ color: isHi ? '#fff' : 'var(--gold)' }} />
                      </div>
                      <span className="text-sm leading-snug" style={{ color: 'var(--earth-strong)', fontFamily: "'DM Sans', sans-serif" }}>
                        {benefit}
                      </span>
                    </li>
                  ))}
                </ul>

                {/* CTA pinned to bottom */}
                <button
                  onClick={goToWhatsApp}
                  className="mt-auto w-full py-3.5 rounded-full text-sm font-semibold transition-all duration-200 cursor-pointer whitespace-nowrap"
                  style={
                    isHi
                      ? { background: 'var(--gold)', color: '#fff', fontFamily: "'DM Sans', sans-serif", boxShadow: '0 4px 20px rgba(255,145,77,0.35)' }
                      : { background: 'var(--gold-pale)', color: 'var(--gold)', fontFamily: "'DM Sans', sans-serif", border: '1px solid var(--gold-border)' }
                  }
                  onMouseEnter={(e) => {
                    if (isHi) {
                      e.currentTarget.style.background = 'var(--gold-hover)';
                      e.currentTarget.style.boxShadow = '0 6px 28px rgba(255,145,77,0.45)';
                    } else {
                      e.currentTarget.style.background = 'var(--gold)';
                      e.currentTarget.style.color = '#fff';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (isHi) {
                      e.currentTarget.style.background = 'var(--gold)';
                      e.currentTarget.style.boxShadow = '0 4px 20px rgba(255,145,77,0.35)';
                    } else {
                      e.currentTarget.style.background = 'var(--gold-pale)';
                      e.currentTarget.style.color = 'var(--gold)';
                    }
                  }}
                >
                  Criar minha música
                </button>
              </div>
            );
          })}
        </div>

        {/* Reassurance */}
        <p
          className="text-center text-xs mt-10"
          style={{ color: 'var(--text-soft)', fontFamily: "'DM Sans', sans-serif" }}
        >
          <i className="ri-lock-line" style={{ color: 'var(--gold)' }} /> Pagamento seguro · Entrega prioritária em até 30 minutos · Garantia de satisfação ou dinheiro de volta em 7 dias
        </p>
      </div>
    </section>
  );
}
